import RelatedPagesComponent from "../../../../components/help/RelatedPagesComponent.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../../../util/events.ts";
import OrderAddressSearchComponent from "../../../../components/order/OrderAddressSearchComponent.tsx";
import {Link} from "react-router-dom";
import {imageMap} from "../../../../images/imageMap.ts";
import Routing from "../../../../Routing.ts";
import TDC5GSetupStepsSectionComponent from "../../../../components/tdc5g/TDC5GSetupStepsSectionComponent.tsx";


export default function StudentsArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <p>
                            Er du studerende og på jagt efter billigt internet, der stadig leverer på hastighed og stabilitet? 
                            Hos Hiper ved vi, at SU’en ikke er stor – men at behovet for hurtigt bredbånd er. Derfor tilbyder 
                            vi billigt internet til studerende, uden at gå på kompromis med kvaliteten.        
                        </p>
                        
                        <h2>
                            Internet til studerende – hurtigt, stabilt og fleksibelt
                        </h2>
                        <p>
                            Som studerende streamer du måske forelæsninger, deltager i online undervisning, 
                            gamer eller slapper af med Netflix. Det kræver en solid internetforbindelse – 
                            og det får du hos os. Vi vil som udgangspunkt anbefale <Link to="/bredbaand/5g-internet">5G-internet</Link> til studerende, 
                            da det er den billigste internetforbindelse, vi udbyder, som samtidig er hurtig. 
                        </p>
                        <p>
                           Lav et adresseopslag herunder for at se, hvilket tilbud som du kan få.
                           <OrderAddressSearchComponent/>
                           <br/><br/>
                            <img src={imageMap.alternative_frontpages.students} alt="Studerende bruger hiper" />
                        </p>


                        <h2>Fordele ved at vælge 5G-internet som studerende</h2>
                        <ol className="list list--number list--image">
                            <li>
                                <p> 
                                    <strong>Meget nem installation</strong><br/>
                                    Med 5G-internet skal du blot indsætte SIM-kortet i 5G-routeren, tilslutte strømstikket og koble dine enheder til wifi. Nemt og sikkert.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>Lynhurtig 5G-hastighed med fri data</strong><br/>
                                    Du kan nå op til 1000 Mbit i download-hastighed med vores 5G-internet. 
                                    Med den 5G-hastighed kan du bl.a. surfe, deltage i online undervisning og strame på livet løs. Du får en stabil dækning og fri data med i dit abonnement.
                                </p>
                            </li>
                            <li>
                                <strong>God, billig og studievenlig pris</strong><br/>
                                Vi har et kampagnetilbud på 5G-internet på 199,-/mdr. de første 3 måneder, herefter 279,-/mdr. Det er en knivskarp pris for en god forbindelse!
                            </li>
                            <li>
                                <strong>Danmarks bedste 5G-dækning</strong><br/>
                                Med Hipers 5G-internet får du adgang til stabilt og lynhurtigt internet i Hiper-kvalitet, med Danmarks bedste 5G-dækning fra TDC NET, der dækker 99,9% af Danmark.
                            </li>
                            <li>
                                <strong>Sublim 5G-router</strong><br/>
                                Du får en lånerouter med i dit abonnement, som er bygget til at levere et stærkt og stabilt wifi-signal til alle dine enheder. 
                                Du får altså det bedste udstyr til at få leveret dit billige internet.
                            </li>
                        </ol>
                         <TDC5GSetupStepsSectionComponent/>

                        <h2>Andre bredbåndsforbindelser til studerende</h2>
                        <p>
                            Vi udbyder også internet via <Link to="/bredbaand/fibernet">fiber</Link> eller <Link to="/bredbaand/kabel-tv-stik">coax</Link>, hvis du ønsker en anden forbindelse end 5G-internet til dit hjem. 
                            Uanset hvilken forbindelse du vælger hos os, får du  altid en sublim låne-router med i dit abonnement, som sikrer dig god wifi i hjemmet. 
                        </p>

                        <h2>Fibernet</h2>
                             <ol className="list list--bullet">
                                <li>
                                    <p>
                                        Den hurtigste og mest stabile forbindelse, perfekt til studiekollektivet eller lejligheden med mange enheder online samtidig.
                                    </p> 
                                </li>
                                <li>
                                    <p>
                                        En fiberforbindelse er lidt dyrere end en 5G-forbindelse, men hvis I bor flere under samme tag, kan I med fordel splitte regningen. 
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Det kan kræve <Link to="/hjaelp/bestilling/fiber-installation">fibernet-installation</Link>, hvis fiberkablerne ikke er ført ind til din bolig, men det kan du tjekke ved at lave et&nbsp;
                                               <button
                                                    className={'link'}
                                                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                                                >
                                                    adresseopslag.
                                                </button>{' '} 
                                    </p>
                                </li>
                            </ol>

                            <h2>Internet via coax</h2>
                             <ol className="list list--bullet">
                                <li>
                                    <p>
                                        Det er også en god forbindelse, som er en anden teknologi end 5G-internet og fibernet. 
                                    </p> 
                                </li>
                                <li>
                                    <p>
                                        Denne forbindelse er også god til at rumme flere enheder på en gang, og du kan også sagtens streame og game på livet løs med denne.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Der er nem opsætning af dit internet, routeren skal blot kobles til dit kabel-tv-stik (coax) i dit hjem. 
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Der er nem opsætning af dit internet, routeren skal blot kobles til dit kabel-tv-stik (coax) i dit hjem. 
                                    </p>
                                </li>
                            </ol>

                         <p>
                            Hvis du er i tvivl om hvilken internetforbindelse, du godt kunne tænke dig samt hvilke fordele og ulemper, 
                            der ved hver forbindelse, kan du læse følgende artikel: <Link to="/hjaelp/internet-og-wifi/hvilket-internet-skal-jeg-vaelge">Hvilket internet skal jeg vælge?</Link>
                        </p>
                             <h2>Skal du have godt og billigt bredbånd som studerende?</h2>
                        <p>
                            Lav et adresseopslag her for at se hvilken forbindelse og pris, du kan få på din adresse:&nbsp;  
                            
                            <button
                                className={'link'}
                                onClick={() => DispatchHighLightAddressSearchEvent(true)}
                            >
                                Tjek din adresse her
                            </button>{' '}
                            
                        </p>
                    </div>
                </div>



            </article>

            <RelatedPagesComponent
                articles={[
                    {
                        "link": Routing.Broadband.TDC5G,
                        "name": "Bestil 5G-internet"
                    },
                    {
                        "link": Routing.Broadband.Fiber,
                        "name": "Bestil fibernet"
                    },
                    {
                        "link": Routing.Broadband.Coax,
                        "name": "Bestil coax internet"
                    },
                    {
                        "link": "/hjaelp/internet-og-wifi/hvilket-internet-skal-jeg-vaelge",
                        "name": "Hvilket Internet skal jeg vælge?"
                    }
                ]}
            />
        </>
    )
}
